export default "__VITE_ASSET__6da848a0__"